import troysnap from '../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap.png';
import troysnap2 from '../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap2.png';
import troysnap3 from '../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap3.png';
import troysnap4 from '../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap4.png';
import troysnap5 from '../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap5.png';
import troysnap6 from '../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap6.png';
import troysnap7 from '../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap7.png';

import yorksnap from '../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap.png';
import yorksnap2 from '../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap2.png';
import yorksnap3 from '../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap3.png';
import yorksnap4 from '../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap4.png';
import yorksnap5 from '../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap5.png';
import yorksnap6 from '../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap6.png';

import riosnap from '../../assets/muvtech/Muvdata/iphonecases/rio-snap/rio-snap.png';

import evosnap from '../../assets/muvtech/Muvdata/iphonecases/evo-snap/evo-snap.png';

const iphonecaseData = [
  // {
  //   id: 1,
  //   type: 'iphonecase',
  //   title: 'Armour Case',
  //   compatibleModels: 'iPhone 16 series, iPhone 15, iPhone 14',
  //   price: 1199,
  //   specs: [
  //     '8ft Drop Tested',
  //     '360° Protection',
  //     'Transparent hybrid PC + TPU',
  //     'Raised camera ring',
  //     'Shock and scratch resistant',
  //     'Lightweight',
  //   ],
  // },
  // {
  //   id: 2,
  //   type: 'iphonecase',
  //   title: 'ARMOUR SNAP',
  //   compatibleModels: 'iPhone 16, 15, 14 (All variants)',
  //   price: 1799,
  //   specs: [
  //     'Dual-layer PC + TPU',
  //     '8ft Drop Tested',
  //     '360° Protection',
  //     'Shock absorbent, antimicrobial',
  //     'Supports wireless charging',
  //   ],
  // },
  // {
  //   id: 3,
  //   type: 'iphonecase',
  //   title: 'AVON SNAP',
  //   compatibleModels: 'iPhone 16 Series',
  //   price: 1999,
  //   specs: [
  //     '10ft Drop Tested',
  //     '3-Tier Structure',
  //     'ShockSorb™ bumpers',
  //     'Scratch-resistant',
  //     'MagClick Compatible',
  //   ],
  // },
  // {
  //   id: 4,
  //   type: 'iphonecase',
  //   title: 'PLYO SNAP',
  //   compatibleModels: 'iPhone 16 Series',
  //   price: 1799,
  //   specs: [
  //     'Transparent Clear Case',
  //     'Metal Camera Ring (1.2mm)',
  //     'Slim & lightweight',
  //     '360° Protection',
  //   ],
  // },
  {
    id: 5,
    type: 'iphonecase',
    title: 'TROY SNAP',
    compatibleModels: 'iPhone 16 Series',
    price: 1999,
    specs: ['Material: TPE', 'Drop & Impact resistant', 'Flexible yet rugged'],
    image: [
      troysnap,
      troysnap2,
      troysnap3,
      troysnap4,
      troysnap5,
      troysnap6,
      troysnap7,
    ],
  },
  {
    id: 6,
    type: 'iphonecase',
    title: 'YORK SNAP',
    compatibleModels: 'iPhone 16 Series',
    price: 1999,
    specs: [
      '10ft Drop Tested',
      'TPU structure with air cushioning',
      'Absorbs 98% shock',
      'Rounded air bumpers',
    ],
    image: [yorksnap, yorksnap2, yorksnap3, yorksnap4, yorksnap5, yorksnap6],
  },
  // {
  //   id: 7,
  //   type: 'iphonecase',
  //   title: 'VIGO SNAP',
  //   compatibleModels: 'iPhone 16 Series',
  //   price: 2199,
  //   specs: [
  //     '2.0mm PC + TPU',
  //     'Aluminum camera ring',
  //     'MagSafe compatible',
  //     'Multi-stand feature',
  //   ],
  // },
  // {
  //   id: 8,
  //   type: 'iphonecase',
  //   title: 'CABO SNAP',
  //   compatibleModels: 'iPhone 16 Series',
  //   price: 2199,
  //   specs: [
  //     'Raised aluminum camera bezel',
  //     'Textured grip panel',
  //     'MagClick supported',
  //   ],
  // },
  // {
  //   id: 9,
  //   type: 'iphonecase',
  //   title: 'EDEN SNAP',
  //   compatibleModels: 'iPhone 16 Series',
  //   price: 1799,
  //   specs: [
  //     '1.2mm aluminum ring',
  //     'Clear, impact-resistant',
  //     'Antimicrobial & shock absorbent',
  //   ],
  // },
  {
    id: 10,
    type: 'iphonecase',
    title: 'RIO SNAP',
    compatibleModels: 'iPhone 16 Series',
    price: 1799,
    specs: [
      'Foldable kickstand',
      'Dual-layer TPU + PC',
      'MagSafe',
      'Wireless charging (up to 20W)',
    ],
    image: [riosnap],
  },
  {
    id: 11,
    type: 'iphonecase',
    title: 'EVO SNAP',
    compatibleModels: 'iPhone 16 Series',
    price: 1999,
    specs: [
      'Foldable stand + MagSafe',
      'TPU + PC',
      'Wireless charging (up to 20W)',
    ],
    image: [evosnap],
  },
];

export default iphonecaseData;
